import { isNullOrEmpty, TasksStatusesFilterReverse } from 'app/helper/utils';

export class Filter {
  idSector: string;
  idFlow: string;
  dateFrom: string;
  dateTo: string;
  idMachine: string;
  search: string;
  betweenDates: object;
  idProcedure: string;
  remainingDays: string;
  status: string;

  constructor(filter) {
    if (!isNullOrEmpty(filter.idSector)) {
      if (filter.idSector.idSector && filter.idSector.idSector.length > 0) {
        this.idSector = filter.idSector.idSector;
      }
    }
    if (!isNullOrEmpty(filter.idFlow)) {
      if (filter.idFlow.idFlow && filter.idFlow.idFlow.length > 0) {
        this.idFlow = filter.idFlow.idFlow;
      }
    }
    if (!isNullOrEmpty(filter.dateFrom)) {
      this.dateFrom = filter.dateFrom;
    }
    if (!isNullOrEmpty(filter.dateTo)) {
      this.dateTo = filter.dateTo;
    }
    if (!isNullOrEmpty(filter.idMachine) && filter.idMachine !== 'Todas') {
      this.idMachine = filter.idMachine;
    }
    if (!isNullOrEmpty(filter.search)) {
      this.search = filter.search.search;
    }
    if (!isNullOrEmpty(filter.status)) {
      this.status = filter.status;
    }
  }
}
